enum SurveysViewpoint {
  OPENING_SUMMARY = 'OPENING_SUMMARY',
  MEMBER_SAVING = 'MEMBER_SAVING',
}

export default SurveysViewpoint;
